module.exports = __webpack_public_path__ + "static/media/rsrcmtr_131.d18378ab.ico";